import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import type { WidgetPhoneMockupConfigurationFormType } from "modules/campaigns/components/Sections/triggers/widget/iframe"
import { getIframeChatConfigQueryKey } from "modules/campaigns/lib/templates/widget/getIframeChatConfigQuery"

export const useUpdateIframeChatConfigMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (props: WidgetPhoneMockupConfigurationFormType) => {
      const { data } = await axios.post(`/integrations/widget/iframe`, props)
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getIframeChatConfigQueryKey() })
    },
  })
}
